<ng-container *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		[hasRefresh]="vo.hasRefresh"
		[actions]="(vo.mode ==='STANDALONE' && vo.userPermissions.has(ElementPermission.Edit))
								|| (vo.mode === 'PROFILE_STANDALONE' && vo.columnModelList.elements.size === vo.savedColumnModels.size)
								? columnModelActions: []"
		[itemsCount]="vo.columnModelList.elements.size"
		(search)="search($event)"
		(refresh)="refreshColumnModels()">
		<div
			class="app-panel__title"
			panel-title>
			<mat-icon [svgIcon]="ComponentIcons.Column"></mat-icon>
			<span
				i18n="@@subscription.columnModel.list.title">
				column-models</span>
		</div>
		<dx-data-grid
			keyExpr="id"
			[elementAttr]="{id: 'subscription-column-model-list',class: 'app-subscription-column-model-list'}"
			[dataSource]="vo.columnModelList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'"
			(onSelectionChanged)="selectColumnModel($event)"
			(onCellHoverChanged)="onCellHover($event)"
			(onContentReady)="onGridReady()"
			(onRowPrepared)="onRowPrepared($event)">

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<dxo-selection
				[mode]="vo.mode === 'STANDALONE' ? 'none': 'single'"></dxo-selection>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<ng-container
				*ngFor="let col of vo.columnModelList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'label'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'40%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="labelTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'description'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable ?? false"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'40%'"
					[visibleIndex]="col.visibleIndex"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'columns'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'10%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="columnsTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'linkedProfileIds'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="false"
					[allowHiding]="false"
					[allowGrouping]="false"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="90"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="profilesTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'status'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="90"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="statusTemplate"></dxi-column>
			</ng-container>

			<dxi-column
				[fixed]="false"
				[allowResizing]="false"
				[allowHiding]="false"
				[allowGrouping]="false"
				[allowSearch]="false"
				[allowSorting]="false"
				[alignment]="'left'"
				[visible]="vo.mode === 'PROFILE_STANDALONE'"
				[visibleIndex]="vo.columnModelList.availableColumns.size"
				[width]="90"
				cellTemplate="newColumnModelTemplate"></dxi-column>

			<dxi-column
				[fixed]="false"
				[allowResizing]="false"
				[allowHiding]="false"
				[allowGrouping]="false"
				[allowSearch]="false"
				[allowSorting]="false"
				[alignment]="'left'"
				[visible]="vo.mode !== 'SIMULATION'"
				[visibleIndex]="vo.columnModelList.availableColumns.size + 1"
				[width]="90"
				[showInColumnChooser]="false"
				cellTemplate="actionsTemplate"></dxi-column>

			<div *dxTemplate="let cell of 'labelTemplate'" class="label-template">
				<mat-icon
					*ngIf="!cell.data['isInSync'] && vo.subscriptionStatus === SubscriptionStatus.Available"
					matTooltip="My tooltip"
					i18n-matTooltip="@@general.status.not-synced"
					[svgIcon]="DcIcons.NotSynced"></mat-icon>

				<span [matTooltip]="cell.data['label']"
					[matTooltipDisabled]="cell.data['label'].length <= 30"
					matTooltipPosition="right">
					{{cell.data['label'] | truncate: 30 : 1 : 'end'}}</span>
			</div>

			<div class="columns-count" *dxTemplate="let cell of 'columnsTemplate'">
				<app-overlay-badge
					*ngIf="cell.data['columns'].size !== 0"
					[icon]="ComponentIcons.Column"
					[value]="cell.data['columns'].size"
					[active]="true"
					[isOpen]="vo.openedOverlayColumnModel.columnModelId === cell.data['id']"
					(overlayDismiss)="closeColumnsPopover()"
					(click)="openColumnsPopover($event, cell.data)">
					<app-popover
						overlayContent
						label="columns"
						i18n-label="@@subscription.columnModel.list.column.columns"
						[icon]="{ iconName: ComponentIcons.Column }"
						[count]="cell.data['columns'].size"
						(adbPopoverClose)="closeColumnsPopover()">
						<div class="columns-details">
							<ng-container *ngFor="let column of vo.openedOverlayColumnModel.columns">
								<app-column-type
									[type]="column['type']"
									[isList]="column['isList']"></app-column-type>
								<span>{{ column.label }}</span>

								<mat-icon
									*ngIf="column['isHashed']; else emptyIcon"
									[svgIcon]="DcIcons.Encrypted">
								</mat-icon>

								<ng-template #emptyIcon>
									<span></span>
								</ng-template>
							</ng-container>
						</div>
					</app-popover>
				</app-overlay-badge>
			</div>

			<div *dxTemplate="let cell of 'profilesTemplate'">
				<app-overlay-badge
					data-style-override
					class="inactive"
					*ngIf="cell.data['linkedProfileIds'].size !== 0"
					[icon]="ComponentIcons.Profile"
					[value]="cell.data['linkedProfileIds'].size"
					[active]="true"
					[isOpen]="false">
					<app-popover
						overlayContent
						label="projects"
						i18n-label="@@subscription.columnModel.list.column.profiles"
						[icon]="{ iconName: ComponentIcons.Profile }"
						[count]="cell.data['linkedProfileIds'].size">
					</app-popover>
				</app-overlay-badge>

			</div>

			<div
				*dxTemplate="let cell of 'statusTemplate'">
					<div *ngIf="cell.data['status'] === ColumnStatus.Warning"
						class="info-badge warning">
						<mat-icon
							[svgIcon]="DcIcons.Warning"></mat-icon>
						<span
							i18n="@@subscription.column.deleted">
							deleted</span>
					</div>
			</div>

			<div *dxTemplate="let cell of 'newColumnModelTemplate'">
				<div *ngIf="!vo.savedColumnModels.get(cell.key)" class="info-badge new">
					<span
						i18n="@@subscription.columnModel.new">
						new</span>
				</div>
			</div>

			<div
				*dxTemplate="let cell of 'actionsTemplate'"
				[hidden]="cell.rowIndex !== currentlyHovered" class="action-template">
				<!-- mode Stepper -->
				<ng-container *ngIf="vo.mode === 'PROFILE_STEPPER'">
					<div class="column-actions-template">
						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="update"
							i18n-matTooltip="@@subscription.columnModel.list.action.update"
							matTooltipPosition="left"
							(click)="updateDraftColumnModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
						</button>
					</div>
				</ng-container>

				<!-- mode Profile-Standalone -->
				<ng-container *ngIf="vo.mode === 'PROFILE_STANDALONE' && !vo.savedColumnModels.get(cell.key)">
					<div class="column-actions-template">
						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="update"
							i18n-matTooltip="@@subscription.columnModel.list.action.update"
							matTooltipPosition="left"
							(click)="updateDraftColumnModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
						</button>

						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="delete"
							i18n-matTooltip="@@subscription.columnModel.list.action.delete"
							matTooltipPosition="left"
							(click)="deleteDraftColumnModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
						</button>
					</div>
				</ng-container>

				<!-- mode Standalone -->
				<ng-container *ngIf="vo.mode === 'STANDALONE' && vo.userPermissions.has(ElementPermission.Edit)">
					<div class="column-actions-template">
						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="simulate"
							i18n-matTooltip="@@subscription.columnModel.list.action.simulate"
							matTooltipPosition="left"
							(click)="simulateColumnModel(cell.data)">
							<mat-icon [svgIcon]="DcIcons.TestApi"></mat-icon>
						</button>

						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="update"
							i18n-matTooltip="@@subscription.columnModel.list.action.update"
							matTooltipPosition="left"
							(click)="updateColumnModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
						</button>

						<button
							mat-icon-button
							class="column-actions-template__menu-btn"
							matTooltip="delete"
							i18n-matTooltip="@@subscription.columnModel.list.action.delete"
							matTooltipPosition="left"
							(click)="deleteColumnModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
						</button>
					</div>
				</ng-container>
			</div>

			<!-- Sorting	-->
			<dxo-sorting mode="multiple"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="10"></dxo-paging>

			<dxo-pager [visible]="true"></dxo-pager>

			<!-- Filterable columns	-->
			<dxo-header-filter [visible]="true"></dxo-header-filter>

			<dxo-filter-row [visible]="true"></dxo-filter-row>

		</dx-data-grid>
	</app-panel>
</ng-container>
